import { atom } from 'recoil';

export const chatState = atom({
  key: 'hasBeenInChat',
  default: false,
});
